module.exports = __webpack_public_path__ + "static/media/S33_W.30d7ba2b.png";